import { render, staticRenderFns } from "./RealVideoCompnent.vue?vue&type=template&id=244f58b7&scoped=true"
import script from "./RealVideoCompnent.vue?vue&type=script&lang=js"
export * from "./RealVideoCompnent.vue?vue&type=script&lang=js"
import style0 from "./RealVideoCompnent.vue?vue&type=style&index=0&id=244f58b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f58b7",
  null
  
)

export default component.exports